import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { discardDraftPpsiNir } from '../actions';
import { getIsDiscardingDraft } from '../selectors';

const useDiscardDraftPpsiNir = () => {
  const dispatch = useDispatch();
  const isDiscardingDraftPpsiNir = useSelector(getIsDiscardingDraft);
  const onDiscardDraftPpsiNir = useCallback(
    (id, formulaCode) => {
      dispatch(discardDraftPpsiNir(id, formulaCode));
    },
    [dispatch]
  );

  return [onDiscardDraftPpsiNir, isDiscardingDraftPpsiNir];
};

export default useDiscardDraftPpsiNir;
